"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Mail } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden rounded-lg border-border/50 shadow-md">
            <div className="aspect-[3/2] w-full animate-pulse bg-muted" />
            <CardContent className="flex flex-col gap-3 p-5">
              <div className="h-6 w-3/4 animate-pulse rounded-md bg-muted" />
              <div className="h-4 w-full animate-pulse rounded-md bg-muted" />
              <div className="h-4 w-2/3 animate-pulse rounded-md bg-muted" />
              <div className="mt-4 flex items-center gap-2">
                <div className="h-3 w-20 animate-pulse rounded-md bg-muted" />
                <div className="h-3 w-20 animate-pulse rounded-md bg-muted" />
              </div>
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-lg border border-dashed border-border bg-muted/30 p-8 text-center">
        <p className="text-muted-foreground">Error al cargar las noticias. Por favor, intente más tarde.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-lg border border-dashed border-border bg-muted/30 p-8 text-center">
        <p className="text-muted-foreground">No se encontraron actualizaciones recientes.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group overflow-hidden rounded-lg border-border/50 shadow-md transition-shadow hover:shadow-lg">
          <Link to={post.link || "#"} className="block">
            <div className="relative aspect-[3/2] w-full overflow-hidden">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                  Sin Imagen
                </div>}
              {post.categories && post.categories.length > 0 && <Badge className="absolute left-3 top-3 rounded-md bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground hover:bg-accent/90">
                  {post.categories[0].name}
                </Badge>}
            </div>
          </Link>
          <CardContent className="flex flex-col gap-3 p-5">
            <h3 className="font-default text-lg font-bold leading-tight text-foreground line-clamp-2">
              <Link to={post.link || "#"} className="hover:text-primary transition-colors">
                {post.title}
              </Link>
            </h3>
            {post.excerpt && <div className="text-sm text-muted-foreground line-clamp-2 font-default" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}
            <div className="mt-auto flex items-center gap-2 pt-2 text-xs font-medium text-muted-foreground">
              {post.date && <time dateTime={post.date}>
                  {new Date(post.date).toLocaleDateString("es-MX", {
              month: "short",
              day: "numeric",
              year: "numeric"
            })}
                </time>}
              <span>•</span>
              <span>Kalisch Acero</span>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function News() {
  const wp_query_params = {
    post_type: "post",
    per_page: 4
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="263824" id="news" className="bg-background text-foreground py-24">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              Noticias y Actualidad
            </h2>
          </div>
          <Link to="#" className="inline-flex items-center text-sm font-semibold text-primary hover:text-secondary transition-colors">
            Ver Todas las Publicaciones
            <svg className="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 4
      }}>
          <BlogGridConsumer />
        </PostsProvider>

        {}
        <div className="mt-16 flex flex-col items-center justify-between gap-8 rounded-lg bg-primary p-8 md:p-12 lg:flex-row shadow-xl">
          <div className="flex w-full flex-col items-start gap-6 sm:flex-row sm:items-center lg:w-1/2">
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg border border-white/20 bg-white/10 text-white">
              <Mail className="h-8 w-8" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-default text-xl font-bold text-primary-foreground md:text-2xl">
                Suscríbase a nuestro Boletín
              </h3>
              <p className="mt-2 text-sm text-primary-foreground/80 md:text-base font-default">
                Reciba las últimas actualizaciones sobre la industria del acero, sostenibilidad y proyectos destacados.
              </p>
            </div>
          </div>
          <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-1/2 lg:justify-end">
            <input type="email" placeholder="Correo electrónico" className="h-12 w-full rounded-md border border-primary-foreground/20 bg-primary-foreground/5 px-4 text-primary-foreground placeholder:text-primary-foreground/50 focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent sm:max-w-sm font-default" required />
            <Button size="lg" className="h-12 shrink-0 rounded-md bg-secondary px-8 font-semibold text-secondary-foreground hover:bg-secondary-600 transition-colors">
              Suscribirse
            </Button>
          </div>
        </div>
      </div>
    </section>;
}